// src/components/signaturePad.js — quadro de assinatura eletrônica (canvas vanilla).
// Sem dependências externas. Suporta toque, mouse e caneta (Pointer Events).
// Feature 013 (RDO) — usado pelo admin (assinar pela contratada) e pelo cliente (assinar/recusar).
//
// API:
//   import { signaturePadHTML, mountSignaturePad } from '@/components/signaturePad.js';
//   bodyHTML = signaturePadHTML({ id: 'sig-cli', hint: '...' });
//   const pad = mountSignaturePad('sig-cli');   // chamar APÓS o HTML estar no DOM
//   pad.isEmpty(); pad.clear(); pad.toDataURL(); await pad.toBlob(); pad.destroy();
import './signaturePad.css';

export function signaturePadHTML(opts = {}) {
  const id = opts.id || 'sigpad';
  const hint = opts.hint || 'Assine no quadro acima usando o dedo (toque) ou o mouse.';
  const ph = opts.placeholder || 'Assine aqui';
  return `<div class="sigpad" data-sigpad="${id}">
    <div class="sigpad-wrap">
      <canvas id="${id}" class="sigpad-canvas"></canvas>
      <div class="sigpad-baseline"></div>
      <div class="sigpad-ph" data-ph="${id}">${ph}</div>
    </div>
    <div class="sigpad-bar">
      <span class="sigpad-hint">${hint}</span>
      <button type="button" class="sigpad-clear" data-sigclear="${id}">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m-9 4v8m4-8v8"/></svg>
        Limpar
      </button>
    </div>
  </div>`;
}

export function mountSignaturePad(id = 'sigpad') {
  const canvas = document.getElementById(id);
  if (!canvas) return null;
  const ph = document.querySelector(`[data-ph="${id}"]`);
  const ctx = canvas.getContext('2d');
  const dpr = Math.max(1, Math.min(3, window.devicePixelRatio || 1));
  let strokes = [], cur = null, drawing = false;

  const pos = (e) => { const r = canvas.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
  function fit() {
    const w = canvas.clientWidth || 300, h = canvas.clientHeight || 172;
    canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    redraw();
  }
  function redraw() {
    ctx.save(); ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, canvas.width, canvas.height); ctx.restore();
    ctx.lineJoin = 'round'; ctx.lineCap = 'round'; ctx.strokeStyle = '#0E0E14'; ctx.fillStyle = '#0E0E14'; ctx.lineWidth = 2.2;
    for (const st of strokes) {
      if (st.length === 1) { ctx.beginPath(); ctx.arc(st[0].x, st[0].y, 1.3, 0, Math.PI * 2); ctx.fill(); continue; }
      ctx.beginPath(); ctx.moveTo(st[0].x, st[0].y);
      for (let i = 1; i < st.length; i++) ctx.lineTo(st[i].x, st[i].y);
      ctx.stroke();
    }
    if (ph) ph.style.display = strokes.length ? 'none' : 'flex';
  }
  function down(e) { e.preventDefault(); drawing = true; cur = [pos(e)]; strokes.push(cur); try { canvas.setPointerCapture(e.pointerId); } catch (_) {} redraw(); }
  function move(e) { if (!drawing) return; e.preventDefault(); cur.push(pos(e)); redraw(); }
  function up() { drawing = false; cur = null; }

  canvas.addEventListener('pointerdown', down);
  canvas.addEventListener('pointermove', move);
  canvas.addEventListener('pointerup', up);
  canvas.addEventListener('pointercancel', up);
  canvas.addEventListener('pointerleave', up);

  const clearBtn = document.querySelector(`[data-sigclear="${id}"]`);
  const onClear = () => { strokes = []; redraw(); };
  clearBtn?.addEventListener('click', onClear);

  let ro = null;
  if (typeof ResizeObserver !== 'undefined') { ro = new ResizeObserver(() => fit()); ro.observe(canvas); }
  // primeira medição após o layout do modal assentar
  requestAnimationFrame(fit);

  return {
    isEmpty: () => strokes.length === 0,
    clear: onClear,
    toDataURL: (type = 'image/png') => canvas.toDataURL(type),
    toBlob: () => new Promise((res) => canvas.toBlob(res, 'image/png')),
    destroy: () => {
      try { ro?.disconnect(); } catch (_) {}
      canvas.removeEventListener('pointerdown', down);
      canvas.removeEventListener('pointermove', move);
      canvas.removeEventListener('pointerup', up);
      canvas.removeEventListener('pointercancel', up);
      canvas.removeEventListener('pointerleave', up);
      clearBtn?.removeEventListener('click', onClear);
    },
  };
}
